import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./Home";
import Register from "./Register";
import Login from "./Login";
import Customer from "./Customer";
import ContactUs from "./ContactUs";
import ModelBuilder from "./ModelBuilder";
import PublicRoutes from "./routes/PublicRoutes";
import PrivateRoutes from "./routes/PrivateRoutes";
import React, { useState, useEffect } from "react";
import { getUser, getToken, setUserSession, resetUserSession } from "./service/AuthService";
import axios from 'axios';
import DataManagement from "./components/dashboard/DataManagement";
import ModelManagement from "./components/dashboard/ModelManagement";
import VendorPriceTable from "./components/dashboard/VendorPriceTable";
import ModelTesting from "./components/dashboard/ModelTesting";
import ResetPassword from "./ResetPassword";
import BehaviorAnalytics from "./components/dashboard/BehaviorAnalytics";
import ManageUserCredits from "./components/dashboard/ManageUserCredits";

const verifyTokenUrl = 'https://dk1aalfdx7.execute-api.us-east-1.amazonaws.com/prod/verify';

function App() {

  const [isAuthenticating, setAuthenticating] = useState(null)
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const token = getToken();
    if (token === 'undefined' || token === undefined || token === null || !token) {
      setAuthenticating(false);
      setIsLoggedIn(false);
      return;
    }

    const requestConfig = {
      headers: {
          'x-api-key': 'ujohgjsp2A9TzwOv6eGZp8EiGy71gXyx3w5Xkhhw'
      }
    }
    const requestBody = {
      user: getUser(),
      token: token
    }

    axios.post(verifyTokenUrl, requestBody, requestConfig).then (response => {
      setUserSession(response.data.user, response.data.token);
      setIsLoggedIn(true);
      setAuthenticating(false);
    }).catch(() => {
      resetUserSession();
      setIsLoggedIn(false);
      setAuthenticating(false);
    })
  }, []);

  const token = getToken();
  if (isAuthenticating && token) {
    return <div className="content">Authenticating...</div>
  }

  return (
    
    <div className="App">
      <Router>
      <div className="content">
        <Navbar />
        <Routes>
          <Route exact path="/" element={<Home />}/>
          <Route exact path="/ContactUs" element={<ContactUs />}/>
          
          <Route element={<PublicRoutes />}>
            <Route path="/Register" element={<Register />}/>
            <Route path="/Login" element={<Login />}/>
            <Route path="/ResetPassword" element={<ResetPassword />}/>
          </Route>
          <Route element={<PrivateRoutes />}>
            <Route path="/Customer" element={<Customer />}/>
            <Route path="/ModelBuilder" element={<ModelBuilder />} />
            <Route path="/DataManagement" element={<DataManagement />} />
            <Route path="/ModelManagement" element={<ModelManagement />} />
            <Route path="/VendorPriceTable" element={<VendorPriceTable />} />
            <Route path="/ModelTesting" element={<ModelTesting />} />
            <Route path="/BehaviorAnalytics" element={<BehaviorAnalytics />} />
            <Route path="/ManageUserCredits" element={<ManageUserCredits />} />
          </Route>
        </Routes>
        <Footer />
      </div>
      </Router>

    </div>
  );
}

export default App;